export default __webpack_public_path__ + "static/media/GMaduroChurchill.2a990e83.png";